import { useContext, useEffect, useState } from 'react';
import styled, { ThemeContext } from 'styled-components';
import { renderStyledElementStyles } from '../../helpers';
import { useRootDispatch, useRootSelector } from '../../../../store/hooks';
import { selectSiteHeader } from '../../../../store/features/siteHeader';
import {
  fetchFestivalProGuestsByCategory,
  sortGuests,
} from '../../../../store/features/festivalProGuests';
import {
  SiteBuilderModule,
  StyledHeading,
  StyledParagraph,
  CallToAction,
} from '../sharedComponents';
import {
  categoryNameMapper,
  CANCELED_CELEB_TYPE,
} from '../../../views/siteBasePages/FestivalProGuestsView/FestivalProGuestsView';
import GuestCard from '../../../views/siteBasePages/FestivalProGuestsView/GuestCategory/GuestCard';
import Spinner from '../../../views/siteBasePages/FestivalProGuestsView/Spinner';

const Wrapper = styled.div`
  ${({ theme }) =>
    renderStyledElementStyles(
      theme,
      theme.siteBuilderModules.festivalProCategoryModule,
    )};
`;

const Body = styled.div`
  ${({ theme }) =>
    renderStyledElementStyles(
      theme,
      theme.siteBuilderModules.festivalProCategoryModule.visualStyles.elements
        .body,
    )};
`;

export default function FestivalProCategoryModule(props) {
  const {
    section: {
      categoryId,
      categoryTitle,
      titleSize,
      introParagraph,
      amount,
      link,
    },
  } = props;

  const dispatch = useRootDispatch();
  const [guests, setGuests] = useState([]);
  const [canceledGuests, setCanceledGuests] = useState([]);
  const {
    data: { festivalProEventId: eventId },
  } = useRootSelector(selectSiteHeader);

  useEffect(() => {
    dispatch(fetchFestivalProGuestsByCategory({ eventId, categoryId, amount }))
      .unwrap()
      .then((data) => {
        const items = data.map((guest) => ({
          ...guest,
          category: guest.categories.includes(CANCELED_CELEB_TYPE)
            ? CANCELED_CELEB_TYPE
            : categoryId,
        }));
        setGuests(
          sortGuests(items.filter((item) => item.category === categoryId)),
        );
        setCanceledGuests(
          sortGuests(
            items.filter((item) => item.category === CANCELED_CELEB_TYPE),
          ),
        );
      })
      .catch((error) => {
        console.error(error);
      });
  }, [dispatch, eventId, categoryId, amount]);

  const themeConfig = useContext(ThemeContext);

  const { festivalProCategoryModule } = themeConfig.siteBuilderModules;

  const dStyles = festivalProCategoryModule.displayStyles;
  const vStyles = festivalProCategoryModule.visualStyles;

  return (
    <>
      <SiteBuilderModule
        section={props.section}
        moduleTheme={{ dStyles, vStyles }}
      >
        <Wrapper>
          <div className="container">
            <div className="row">
              <div className="col-xs-12">
                {categoryTitle && (
                  <StyledHeading
                    content={categoryTitle}
                    as={titleSize}
                    displayStyles={dStyles}
                  />
                )}
                {introParagraph && (
                  <StyledParagraph
                    content={introParagraph}
                    displayStyles={dStyles}
                  />
                )}
              </div>
            </div>
            {guests.length === 0 ? (
              <div className="text-center">
                <Spinner />
              </div>
            ) : (
              <Body>
                <div className="row">
                  {guests.map((guest) => (
                    <div key={guest.id} className="col-xs-6 col-sm-3">
                      <GuestCard guest={guest} />
                    </div>
                  ))}
                </div>
                {link?.shown && (
                  <div className="row">
                    <div className="col-xs-12 text-center">
                      <CallToAction
                        ctaConfig={link}
                        style={{ marginTop: '20px' }}
                      />
                    </div>
                  </div>
                )}
              </Body>
            )}
          </div>
        </Wrapper>
      </SiteBuilderModule>
      {canceledGuests.length > 0 && (
        <SiteBuilderModule
          section={props.section}
          moduleTheme={{ dStyles, vStyles }}
        >
          <Wrapper>
            <div className="container">
              <div className="row">
                <div className="col-xs-12">
                  <StyledHeading
                    content={categoryNameMapper.Canceled}
                    as={titleSize}
                    displayStyles={dStyles}
                  />
                </div>
              </div>
              <Body>
                <div className="row">
                  {canceledGuests.map((guest) => (
                    <div key={guest.id} className="col-xs-6 col-sm-3">
                      <GuestCard guest={guest} />
                    </div>
                  ))}
                </div>
              </Body>
            </div>
          </Wrapper>
        </SiteBuilderModule>
      )}
    </>
  );
}
